import React from 'react';
import { Progress, Space, Flex, Spin } from 'antd';

export const FileGeneratorProgress = ({ progress, setProgress, progressText, isGenerating}) => {

  return (
    <Flex vertical align="center" gap="middle">
      <Space direction="vertical">
    {isGenerating && (
        <div className="overlay">
          <div className="overlay-content">
            <Spin size="large" />
            <div style={{ marginTop: 20 }}>
              <Progress percent={progress} status={isGenerating ? 'active' : 'success'}/>
              <p>{progressText}</p>
            </div>
          </div>
        </div>
      )}
      </Space>
    </Flex>
    
  );
};
